<script setup lang="ts">
import type { CatalogueItem } from '@/models/Catalogue';
import gettext from '@/i18n/gettext';

const { $gettext } = gettext;

const props = defineProps<{
  modelValue: boolean;
  item: CatalogueItem | null;
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
  (e: 'confirm'): void;
}>();

const handleConfirm = () => {
  emit('confirm');
  emit('update:modelValue', false);
};

const handleCancel = () => {
  emit('update:modelValue', false);
};
</script>

<template>
  <v-dialog
    :model-value="props.modelValue"
    max-width="500px"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <div class="pa-6 bg-white" style="border-radius: 8px">
      <div class="d-flex align-center mb-4">
        <h2 class="text-h5">{{ $gettext('Delete Item') }}</h2>
        <v-spacer />
        <v-btn icon="mdi-close" variant="text" @click="handleCancel" />
      </div>

      <div>
        <p>{{ $gettext('Are you sure you want to delete this item?') }}</p>
        <p v-if="props.item" class="font-weight-bold">{{ props.item.name }}</p>
      </div>

      <div class="d-flex justify-end mt-6">
        <v-btn
          color="grey-darken-1"
          variant="text"
          class="mr-2"
          @click="handleCancel"
        >
          {{ $gettext('Cancel') }}
        </v-btn>
        <v-btn color="error" variant="text" @click="handleConfirm">
          {{ $gettext('Delete') }}
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>
